:host {
  background-color: var(--white-layout-301-level-0-elevation);
}
.wrapper {
  flex-direction: column;
  color: var(--body-text-arrows-400);

  .error-state {
    margin-top: 100px;
  }

  gz-landing-page-template[hidden] {
    display: none;
  }
}

.skeleton {
  &[hidden] {
    display: none;
  }

  display: grid;
  grid-gap: calc(2 * var(--spacer));
  max-width: 1366px;
  width: 100%;
  margin: 15px auto;
  grid-template-areas:
    'header header header header header-top header-top'
    'header header header header header-top header-top'
    'header header header header header-bottom header-bottom'
    'integrations integrations integrations integrations integrations integrations'
    'news news news news news news'
    'masterclass masterclass masterclass masterclass masterclass masterclass';

  .card {
    border-radius: 4px;
    border: 1px solid;
    border-color: var(--chart-101-pressed-dividers);
    padding: calc(var(--spacer) * 6) calc(var(--spacer) * 3) calc(var(--spacer) * 6) calc(var(--spacer) * 3);
    flex: 1;

    gz-title {
      font-family: var(--font-family-secondary);
    }

    gz-title,
    gz-text {
      color: var(--chart-300-icon-buttons);
      line-height: normal;
    }

    .gravity-zone-title {
      margin-bottom: calc(4 * var(--spacer));
      line-height: 60px;
    }

    .welcome-text {
      line-height: 27px;
    }

    .large-title {
      height: 60px;
      margin-bottom: calc(4 * var(--spacer));
    }
  }

  .news-card {
    padding: 0;

    .image-placeholder {
      height: 223px;
      background-color: var(--grey-layout-200-disabled);
    }

    .news-footer {
      padding: calc(var(--spacer) * 6) calc(var(--spacer) * 3) calc(var(--spacer) * 6) calc(var(--spacer) * 3);
    }
  }

  .news {
    margin-top: calc(3 * var(--spacer));
  }

  .group {
    display: flex;
    gap: calc(2 * var(--spacer));
    margin-top: calc(2 * var(--spacer));
  }

  gz-loader {
    --loader-height: 40px;
    --loader-border-radius: 20px;
    --loader-padding-bottom: calc(4 * var(--spacer));
  }
}
